import Cookie from "./cookies";

export default class SwConsentBar extends ContaoWebpack.Plugin {
  elements = [];

  init() {
    this.options = {
      ...{
        text: "",
        buttons: {},
      },
      ...this.options,
    };

    this.el.classList.add("sw-consent-bar-initialized");

    this.cookieConfig = new Cookie();

    let consentBar = "";
    consentBar += '<div class="sw-consent-bar-teaser-text col-9">';
    consentBar += this.options.text;
    consentBar += "</div>";

    consentBar += '<div class="sw-consent-bar-buttons col-12">';
    consentBar += '<div class="row">';
    for (const type in this.options.buttons) {
      consentBar += '<div class="col">';
      consentBar +=
        '<button class="btn btn-primary sw-consent-bar-button-' +
        type +
        '">' +
        this.options.buttons[type].title +
        "</button>";
      consentBar += "</div>";
    }
    consentBar += "</div>";
    consentBar += "</div>";

    consentBar += this.cookieConfig.getTemplate();

    this.el.innerHTML = consentBar;

    if (this.cookieConfig.is("all") === "false") {
      this.el.classList.add("sw-consent-bar-rejected-all");
    } else if (this.cookieConfig.is("all") !== undefined) {
    //   this.handleCookies();
    }

    this.handleCookies();

    for (const type in this.options.buttons) {
      this.options.buttons[type].button = this.el.querySelector(
        ".sw-consent-bar-button-" + type
      );
      if (this.options.buttons[type].callback === undefined) {
        this.options.buttons[type].button.addEventListener(
          "click",
          (event) => {
            this["button" + this.ucfirst(type)](event);
          }
        );
      } else {
        this.options.buttons[type].button.addEventListener(
          "click",
          (event) => {
            this.options.buttons[type].callback(event);
          }
        );
      }
    }

    this.cookieEvents();

    this.reopenElements = document.querySelectorAll(".sw-open-consent-bar");
    for (const el of this.reopenElements) {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        this.el.classList.add("sw-consent-bar-open");
      });
    }

    this.acceptSingleCookie = document.querySelectorAll("[data-sw-consent-bar-accept]");
    for (const el of this.acceptSingleCookie) {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        this.cookieConfig.save(el.dataset.swConsentBarAccept, true);
        this.handleCookies(true);
      });
    }

    this.configContainer = this.el.querySelector(".sw-consent-bar-configs");
    this.buttonsContainer = this.el.querySelector(
      ".sw-consent-bar-buttons"
    );

    if (this.cookieConfig.is("all") === undefined) {
      setTimeout(() => {
        this.el.classList.add("sw-consent-bar-open");
      }, 250);
    }
  }

  setCookie(name, value) {
    this.cookieConfig.save(name, value);
  }

  handleCookies(triggered = false) {
    const cookies = this.cookieConfig.cookies;
    this.el.classList.add("sw-consent-bar-accepted-all");

    for (const c in cookies) {
      eval("(" + cookies[c].unload.toString() + ")()");
      if (this.cookieConfig.get(cookies[c].cookieName) === "true") {
        eval("(" + cookies[c].callback.toString() + ")()");
      }
    }
  }

  buttonReject() {
    this.cookieConfig.all(false);
    for (const c in this.cookieConfig.cookies) {
      this.cookieConfig.save(
        this.cookieConfig.cookies[c].cookieName,
        false
      );
      eval("(" + this.cookieConfig.cookies[c].unload.toString() + ")()");
    }
    this.close();
  }

  buttonConfig(event) {
    this.configContainer.classList.toggle("sw-consent-bar-configs-open");
    this.buttonsContainer.classList.toggle("sw-consent-bar-buttons-hide");
    event.target.classList.toggle("inactive");
  }

  buttonAccept() {
    this.cookieConfig.all(true);
    for (const c in this.cookieConfig.cookies) {
      this.cookieConfig.save(
        this.cookieConfig.cookies[c].cookieName,
        true
      );
    }
    this.handleCookies();
    this.close();
  }

  close() {
    this.el.classList.remove("sw-consent-bar-open");
  }

  ucfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  cookieEvents() {
    const acceptAll = this.el.querySelector(
        ".sw-consent-bar-configs-button-acceptAll"
      ),
      save = this.el.querySelector(".sw-consent-bar-configs-button-save");

    acceptAll.addEventListener("click", () => {
      setTimeout(() => {
        this.configContainer.classList.toggle(
          "sw-consent-bar-configs-open"
        );
        this.buttonsContainer.classList.toggle(
          "sw-consent-bar-buttons-hide"
        );
      }, 500);

      this.cookieConfig.all(true);
      for (const c in this.cookieConfig.cookies) {
        this.cookieConfig.save(
          this.cookieConfig.cookies[c].cookieName,
          true
        );
      }
      this.handleCookies(true);
      this.close();
    });
    save.addEventListener("click", () => {
      setTimeout(() => {
        this.configContainer.classList.toggle(
          "sw-consent-bar-configs-open"
        );
        this.buttonsContainer.classList.toggle(
          "sw-consent-bar-buttons-hide"
        );
      }, 500);

      this.cookieConfig.all(true);

      for (const c in this.cookieConfig.cookies) {
        const checkbox = this.el.querySelector(
          '.sw-consent-bar-configs [data-sw-consent-bar-configs="' +
            this.cookieConfig.cookies[c].cookieName +
            '"]'
        );
        this.cookieConfig.save(
          checkbox.dataset.swConsentBarConfigs,
          checkbox.checked
        );
        checkbox.checked = false;
        checkbox.setAttribute("checked", false);
      }

      this.handleCookies(true);
      this.close();
    });
  }

  executeScriptTags(scriptTags, type) {
    scriptTags.forEach(function (script) {
      var scriptElement = document.createElement("div");
      scriptElement.innerHTML = script;
      var scriptTag = scriptElement.firstChild;
      // document.body.appendChild(scriptTag);
      // scriptTag.setAttribute('data-sw-consent-bar-content-type', type);

      if (scriptTag.src) {
        var newScript = document.createElement("script");
        newScript.src = scriptTag.src;
        newScript.setAttribute('data-sw-consent-bar-content-type', type);
        document.body.appendChild(newScript);
      }
    });
  }

  removeScriptTags(type) {
    let scripts = document.querySelectorAll('[data-sw-consent-bar-content-type="' + type + '"]');

    if (scripts.length) {
      scripts.forEach((script) => {
        script.remove()
      })
    }
  }
}
